<nav id="menu-services" (keyup.escape)="close()" aria-label="Services Menu">
    <div id="services-header">
        <div id="services-header-icon">
            <img
                width="19"
                height="13"
                ngSrc="images/icons/transnetyx-icon.svg"
                [alt]="'transnetyx' | translate"
                id="transnetyx-icon" />
        </div>
        <p>{{ 'toolbar.servicesPanel.header' | translate }}</p>
    </div>

    <a id="quickorder-link" [href]="quickorderUrl" target="_blank" autofocus aria-label="Go to QuickOrder">
        <div>
            <img ngSrc="images/icons/quickorder.svg" id="quickorder-icon" height="30" width="30" />
            <label for="quickorder-icon" id="quickorder-label">{{
                'toolbar.servicesPanel.quickorder' | translate
            }}</label>
        </div>
        <i class="fa-regular fa-arrow-up-right-from-square"></i>
    </a>

    <a
        id="genetic-monitoring-link"
        [href]="geneticMonitoringUrl"
        target="_blank"
        autofocus
        aria-label="Go to Genetic Monitoring">
        <div>
            <img ngSrc="images/icons/genetic-monitoring-icon.svg" id="genetic-monitoring-icon" height="30" width="30" />
            <label for="genetic-monitoring-icon" id="genetic-monitoring-label">{{
                'toolbar.servicesPanel.geneticMonitoring' | translate
            }}</label>
        </div>
        <i class="fa-regular fa-arrow-up-right-from-square"></i>
    </a>

    <a id="microbiome-link" [href]="microbiomeUrl" target="_blank" aria-label="Go to Microbiome">
        <div>
            <img ngSrc="images/icons/microbiome-icon.svg" id="microbiome-icon" height="30" width="30" />
            <label for="microbiome-icon" id="microbiome-label">{{
                'toolbar.servicesPanel.microbiome' | translate
            }}</label>
        </div>
        <i class="fa-regular fa-arrow-up-right-from-square"></i>
    </a>

    <a id="tissue-link" [href]="tissueUrl" target="_blank" aria-label="Go to Tissue">
        <div>
            <img ngSrc="images/icons/tissue-icon.svg" id="tissue-icon" height="30" width="30" />
            <label for="tissue-icon" id="tissue-label">{{ 'toolbar.servicesPanel.tissue' | translate }}</label>
        </div>
        <i class="fa-regular fa-arrow-up-right-from-square"></i>
    </a>

    <a id="tag-center-link" [href]="tagCenterUrl" target="_blank" aria-label="Go to TAGCenter">
        <div>
            <img ngSrc="images/icons/tag-center-icon.svg" id="tag-center-icon" height="30" width="30" />
            <label for="tag-center-icon" id="tag-center-label">{{
                'toolbar.servicesPanel.tagCenter' | translate
            }}</label>
        </div>
        <i class="fa-regular fa-arrow-up-right-from-square"></i>
    </a>
</nav>
